import React from 'react';
import { selectCurrentData } from '../App/selectors';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { setDataPresentation } from '../App/actions';

import { platformHandler } from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'

import { COLOR } from '../App/constants';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

//Iconos a usar
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import GroupIcon from '@material-ui/icons/Group';

import {FwScene} from './FwScene'
import FwModalLoader from '../components/FwModalLoader';

import { FwTutorialClass } from '../components/FwTutorialClass'



const styles = theme => ({
  input: {
    display: 'none',
  },
  paperRoleSelection: {
    maxHeight: 320,
    width: 480,
    minHeight: 200,
    margin: 10,
    height: '50%',    
    borderRadius: '10px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },
  flipwitContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',    
  },  
  paperContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  paperTitle: {
    color: 'black',
    //height: '17%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: "auto",
    boxShadow: '0 4px 2px -2px ' + COLOR.FLIPWIT_COLOR_2,
  },
  paperContent: {
    padding: 12,
  },
  paperRoleSelectionDown: {    
  },
  labelTitlePaper: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.3em',
    color: COLOR.FLIPWIT_COLOR_2,
  },
  iconPaperTitle: {
    fontSize: '1.6em',
    margin: 8,
  },
  middleBoxPaper: {
    //height: '55%',
    display: 'flex',
    //Se hace un translate en vez de usar margin ya que
    //el margin de arriba y abajo se calculan con el width
    //y no con el height y eso no sirve
    //transform: 'translateY(20%)',
    //margin: '0% 5%',
    fontSize: '0.9em',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',
    margin: "16px 0px",
    padding: "0px 16px",
  },
  bottomBoxPaper: {
    //height: '28%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: "auto",
  },
  codeTextField: {
    width: '100%',  
    marginTop: '1.5em',
  },
  button: {
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    color: 'white',
    width: '80%',
    minWidth: 100,
    marginBottom: "24px",
    '&:hover': {
      backgroundColor: COLOR.FLIPWIT_COLOR_2,
     }   
  },
  [theme.breakpoints.down(520)]: {
    paperRoleSelection: {
      width: 370,      
    },    
  },
  [theme.breakpoints.down(1000)]: {    
    paperRoleSelectionDown: {           
      marginBottom: "65px",
    },    
    paperRoleSelection: {
      height: 'auto',
    }
  },
  //Cuando no caben los 2 papers en la misma fila entonces los pone uno encima del 
  //otro y toma estos css adicionales
  /*[theme.breakpoints.down(1008)]: {
    paperRoleSelection: {
      width: 295,
      height: '45%',   
    },
    paperRoleSelectionDown: {           
    }
  },

  [theme.breakpoints.down(598)]: {
    paperRoleSelection: {
      alignSelf: 'flex-end',         
    },
    paperRoleSelectionDown: {
      alignSelf: 'flex-start',      
    }
  },
  '@media (max-height: 600px)': {   
    middleBoxPaper: {
      fontSize: '0.8em',      
    },
    codeTextField: {
      marginBottom: 0,
    },
    paperRoleSelection: {
      margin: '1% 8px',     
      height: '48%',  
    },
    flipwitContent: {
      height:'calc(100% - 34px)',      
      position: 'relative',
      top: -5,
    },        
  },
  '@media (max-height: 450px)': {
    middleBoxPaper: {
      fontSize: '0.8em',      
    },
    codeTextField: {
      marginTop: -14,
      marginBottom: 0,
    },
    paperRoleSelection: {
      margin: '2px',     
      height: '50%',  
      minHeight: 170,
    },
    flipwitContent: {
      height:'calc(100% - 34px)',      
      position: 'relative',
      top: -5,
    },    
    inputTest: {
      display: 'none',
    },
  },*/
  
});


class Role extends FwScene {

	state = {
    code:"",
    autoViewerId: "",
    showTutorial: false,
    showLoader:false
  };

  constructor(props) {
      super(props); 
  
      this.handleKeyPress = this.handleKeyPress.bind(this);
  
      console.log('window ',window)
      //Si en la url recibio un codigo para unirse, ejemplo app.flipwit.com/1234
      if(window.codeByUrl!=="" && window.codeByUrl!=null) {
        console.log('ingreso')
        if( !platformHandler.isLAN ){
          console.log('what it is ' + window.codeByUrl)
          if( window.codeByUrl.startsWith("v=")){
            this.state.autoViewerId = window.codeByUrl.substring(2);
          }
          else if( window.codeByUrl.startsWith("t=")){
            this.state.showTutorial = true;
          }
          else {
            this.state.code = window.codeByUrl;          
          }
        }
        //this._setFormValue ('textFieldOne',window.codeByUrl)
      }

      this.tutorial = new FwTutorialClass();
  }

	componentDidMount(){
		platformHandler.checkTitleBarScene("Role");		  

    if(this.state.showTutorial) {
      this.tutorial.setSteps([       
        {
          element: '#paperExhibitor',
          intro: languageManager.getLangWord('LOGIN_TUTORIAL_STEP1'),
        },
      ]);
      
      this.tutorial.setShowTutorial(true);
      this.tutorial.colocarEstadoTutorial(0);  
      this.forceUpdate();
    }

    if(this.state.code!='') {
      this.onButtonJoin(null, false );
    } 
    else{
      if( this.state.autoViewerId != ""){
        this.checkAutoViewer();
      }
    }

    //TODO2 Esto es para que se una de una al 5483 y probar PresentationUser
    //this.setState({fromUserInteraction:true})
    //platformHandler.joinPresentation( '3015' , this.callback.bind(this) );          
	}

  checkAutoViewer( ){
    this.setState({ showLoader:true }) 
    document.activeElement.blur();
    platformHandler.autoviewerAction( "checkId", this.state.autoViewerId, this.callbackAutoViewer );
  };

  callbackAutoViewer = ( data) => {
    if(  data.success ){
      this.dataAutoviewer = data;
      //this.setState({ showLoader:false, showDialog:false, showDialogJoin: true,autoviewer:true })
      platformHandler.autoviewerAction( "join", this.dataAutoviewer, null );
      
      /*this.openModal({title:languageManager.getLangWord("TITLE_JOIN_DIALOG"),message: languageManager.getLangWord("DESC_JOIN_DIALOG")
        ,buttons: [{label:languageManager.getLangWord("CONTINUE"),callback:() => this.optionDialogConfig(1)}]}) 
      this.setState({ showLoader:false, autoviewer:true  })*/
      //this.setState({ showLoader:false, showDialog:false, showDialogJoin: true,autoviewer:true })
    }
    else{
      this.setState({ showLoader:false })
      this.openModal({title:languageManager.getLangWord("ERROR_JOIN_TITLE"),message: languageManager.getLangWord("ERROR_AUTOVIEWER_DESC")})      
    }    
  }

  handleKeyPress(evt){
    if (evt.key === 'Enter') {
      this.onButtonJoin(null);
    }
  }

	startWithoutInternet(){
		platformHandler.startWithInternet( false );
		platformHandler.startExhibiting();
	}

	onButtonExhibitor = (event) => {
      this.setState({showLoader:true})
		  platformHandler.startWithInternet( true );
	    platformHandler.enableNoSleep( true );
	    platformHandler.startExhibiting();
	};

  onButtonJoin = (evt, fromUserInteraction = true ) => {
    this.setState({ showLoader:true, fromUserInteraction:fromUserInteraction }) 
    if( fromUserInteraction ){
      platformHandler.enableNoSleep( true );
    }
    document.activeElement.blur();
    console.log(this.state.code)
    platformHandler.joinPresentation( this.state.code, this.callback.bind(this) );
  };

  verifyConnectWithoutAsk = (dataJoin) => {

    try {
      return this.dataJoin.resp.config.connectWithoutAsk?true:false;
    }
    catch(e) {
      return false;
    }
  }

  followJoinFlow = () =>{
    console.log('dataJoin ', this.dataJoin)
    if( this.state.fromUserInteraction || this.verifyConnectWithoutAsk(this.dataJoin)){
      this.optionDialogConfig( 1 );
    }
    else{
      this.openModal({title:languageManager.getLangWord("TITLE_JOIN_DIALOG"),message: languageManager.getLangWord("DESC_JOIN_DIALOG")
        ,buttons: [{label:languageManager.getLangWord("CONTINUE"),callback:() => this.optionDialogConfig(1)}],closeOnClick:false})  
      this.setState({ showLoader:false });
      //this.setState({ showLoader:false, showDialog:false, showDialogJoin: true,autoviewer:false })
    }
  }

   optionDialogConfig = ( value ) =>{
    if( value ){
      if( !this.state.fromUserInteraction ){ //viene del dialogo que avisa que se va a unir
        platformHandler.enableNoSleep( true );
      }
      if( this.state.autoviewer){
        platformHandler.autoviewerAction( "join", this.dataAutoviewer, null );
      }
      else{
        console.log('SE VA A UNIR CON data',this.dataJoin)
        var data = this.dataJoin;
        if(this.dataJoin.resp) platformHandler.setCurrentSlidesConfig(this.dataJoin.resp.config);
        this.props.dispatch(setDataPresentation( data.resp.name, data.resp.userFirebase ));
        platformHandler.joinSession( data );
      }

      this.closeModal();
    }
    else{
      //this.setState({ showDialogJoin: false,autoviewer:false })
    }
  }  

  waitingFlow = ( data ) =>{
    if( data.urlWait ){
      platformHandler.openWaitingScreen( data.urlWait );
    }
  }

  callback( data){
    console.log('llega',data)

    if( data.success ){
      this.dataJoin = data;

      if( data.domain ){
        window.codeByUrl = data.domain;
      }

      if( data.resp ){
        this.followJoinFlow();
      }
      else{
        this.waitingFlow( data );
      }
    }
    else{
      this.setState({showLoader:false})
      this.openModal({title:languageManager.getLangWord("ERROR_JOIN_TITLE"),message: languageManager.getLangWord("ERROR_JOIN_DESC")})      
    }
  }

  render() {
		const { classes } = this.props;
		console.log('this. props', this.props.pptName)

		return(
		<React.Fragment>
          {this.state.showLoader && <FwModalLoader />}   
          {this.tutorial.getComponent()}      
          <Paper className={classes.paperRoleSelection}>
            <div className={classes.paperTitle}>
              <div className={classes.labelTitlePaper}><GroupIcon className={classes.iconPaperTitle}/>{languageManager.getLangWord("TITLE_JOIN")}</div>              
            </div>
            <div className={classes.middleBoxPaper}>
              <div>{languageManager.getLangWord("DESC_JOIN")}</div>
              <div style={{width: '75%'}}>                
              <TextField    
                value={this.state.code}
                onChange={e => this.setState({ code: e.target.value })}             
                id="codigo"
                label={languageManager.getLangWord("ENTER_CODE")}
                className={classes.codeTextField}
                onKeyPress={this.handleKeyPress}
                margin="normal"
                InputLabelProps={{ classes: { root: classes.inputTest } }} />
              </div>                
            </div>
            <div className={classes.bottomBoxPaper}>
              <Button variant="contained" className={classes.button} onClick={this.onButtonJoin}>
                {languageManager.getLangWord("JOIN_BUTTON")}
              </Button>
            </div>                                 
          </Paper>
          <Paper id={"paperExhibitor"} className={[classes.paperRoleSelection,classes.paperRoleSelectionDown].join(' ')}>
            <div className={classes.paperTitle}>
              <div className={classes.labelTitlePaper}><RecordVoiceOverIcon className={classes.iconPaperTitle}/>{languageManager.getLangWord("TITLE_EXHIBITOR")}</div>              
            </div>
            <div className={classes.middleBoxPaper}>{languageManager.getLangWord("DESC_EXHIBITOR")}</div>
            <div className={classes.bottomBoxPaper}>
              <Button variant="contained" className={classes.button} onClick={this.onButtonExhibitor}>
                {languageManager.getLangWord("EXHIBITOR_BUTTON")}
              </Button>
            </div>                                 
          </Paper>  
        </React.Fragment>       
	    );
	}
}

const mapStateToProps = state => {  	
  return {
  	pptName: selectCurrentData(state).slideName,  
    language: state.containers.appReducer.language,    
  }
};

Role.contextTypes = {
  store: PropTypes.object
};

Role.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

/*const select = state => state;*/

// Wrap the component to inject dispatch and state into it
//export default connect()(withStyles(styles,{ withTheme: true })(App));
export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(Role));

//export default connect(mapStateToProps)(Role);



// WEBPACK FOOTER //
// ./src/containers/scenes/Role.js